

import restService from "../rest-service/RestService";
import { IImpersonatingUserInfo, ILoginInfoModel, IPasswordChangeModel } from "./Models";

interface ILoginInfo {
    name: string;
}

interface ImpersonatorInfo {
    customerID: number;
    globalLoginID: number;
}


const LoginDataService = {

    getLoginInfo: async function(userName: string, abortSignal?: AbortSignal): Promise<ILoginInfoModel> {
        const response = await restService.post<ILoginInfo, ILoginInfoModel>("login/info", {name: userName}, abortSignal);
        return response.data;
    },
    sendForgotPassword: async function(email: string, abortSignal?: AbortSignal): Promise<void> {
        await restService.put<null, void>(`/login/${email}/forgotpassword`, null, abortSignal);
    },
    sendOtpEmail: async function(customerID: number, email: string, abortSignal?: AbortSignal): Promise<void> {
        await restService.put<null, void>(`/login/${email}/customers/${customerID}/sendotpemail`, null, abortSignal);
    },
    updatePassword: async function(data: IPasswordChangeModel, abortSignal?: AbortSignal): Promise<void> {

        await restService.put<IPasswordChangeModel, void>(`login/${data.loginName}/changepassword`, data, abortSignal);
    },



    getImpersonatingUserInfo: async function (customerID: number, globalLoginID: number): Promise<IImpersonatingUserInfo> {
        const path = "login/impersonating-user-info";

        const  queryParams: ImpersonatorInfo = {
            customerID: customerID,
            globalLoginID: globalLoginID
        };

        const result = await restService.post<ImpersonatorInfo, IImpersonatingUserInfo >(path, queryParams);
        return result.data;
    }
};

export default LoginDataService;